import { render, staticRenderFns } from "./BaseAd.vue?vue&type=template&id=5eeb357f&scoped=true&"
import script from "./BaseAd.vue?vue&type=script&lang=js&"
export * from "./BaseAd.vue?vue&type=script&lang=js&"
import style0 from "./BaseAd.vue?vue&type=style&index=0&id=5eeb357f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eeb357f",
  null
  
)

export default component.exports